import dayjs from 'dayjs';
import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import { getPropByString } from '../../../../../utils';

export default function DateSky({ name, formik, value: _value, formIsSubmit, skipDateValidation = false }) {
  const handleChange = (e) => {
    if (e === null) return;
    // Convertir la date sélectionnée en timezone Europe/Paris à 9h du matin
    const selectedDate = dayjs.tz(dayjs(e).format('YYYY-MM-DD') + ' 09:00', 'Europe/Paris');
    formik.setFieldValue(name, selectedDate.toDate(), formIsSubmit);
  };

  const error = getPropByString(formik.errors, name);

  // L'admin système peut sélectionner n'importe quelle date (y compris passée ou jour même)
  const minDate = skipDateValidation ? undefined : dayjs().add(2, 'day');

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
      <DesktopDatePicker
        onChange={handleChange}
        minDate={minDate}
        maxDate={dayjs().add(6, 'month')}
        value={dayjs(_value)}
        slotProps={{
          textField: {
            id: name,
            name: name,
            size: 'small',
            required: true,
            error: Boolean(error),
            helperText: error,
          },
        }}
      />
    </LocalizationProvider>
  );
}
